import { call, delay, put, select, takeEvery } from 'redux-saga/effects';
import * as licenseeActions from '../../actions/licensee/licenseeActions';
import history from "../../../../../common/history";
import { getCompanyInfoRequest } from "../../../api/licensee/getCompanyInfoRequest";
import { errorProcessing } from "../../../../Employees/api/errorProcessing";
import { updateCompanyRequest } from "../../../api/licensee/updateCompanyRequest";
import showSuccessWindow from "../../../../../common/components/successPopup/successPopup";
import { successCompanyUpdation } from "../../../components/Licensee/success";

const getProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  )
};
const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};
const getCompanyId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.companyId
  );
};

function* getCompanyInfoSaga() {
  let companyId = yield select(getCompanyId);
  if (companyId){
    try {
      const response = yield call(getCompanyInfoRequest, companyId);
      yield put(licenseeActions.getCompanyInfoSuccess(response))
    } catch (e) {
      yield put(licenseeActions.getCompanyInfoFailure(errorProcessing(e)))
    }
  } else {
    yield delay(500);
    let companyId = yield select(getCompanyId);
    companyId
      ? yield put(licenseeActions.getCompanyInfo(companyId))
      : history.push('/authorization/profiles');
  }
}

function* updateCompanySaga(action) {
  let profileId = yield select(getProfileId);
  let companyId = yield select(getCompanyId);
  let userId = yield select(getUserId);
  if (profileId){
    try {
      const response = yield call(updateCompanyRequest, userId, profileId, companyId, action.payload);
      yield put(licenseeActions.updateCompanyInfoSuccess(response));
      showSuccessWindow(successCompanyUpdation(response.nameLegal));
    } catch (e) {
      yield put(licenseeActions.updateCompanyInfoFailure(e))
    }
  } else {
    yield delay(500);
    let companyId = yield select(getCompanyId);
    companyId
      ? yield put(licenseeActions.updateCompanyInfo(companyId))
      : history.push('/authorization/profiles');
  }
}

export function* licenseeWatcher(action) {
  yield takeEvery(
    licenseeActions.getCompanyInfo.toString(),
    getCompanyInfoSaga
  );
  yield takeEvery(
    licenseeActions.updateCompanyInfo.toString(),
    updateCompanySaga
  )
}
